/* Raw Water Co. v2 — product detail tabs toggle. */
(function () {
  function init(section) {
    if (section.dataset.v2Init) return;
    section.dataset.v2Init = "1";
    var btns = section.querySelectorAll("[data-v2-tab]");
    var panels = section.querySelectorAll("[data-v2-panel]");
    btns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var idx = btn.getAttribute("data-v2-tab");
        btns.forEach(function (b) { b.classList.toggle("is-active", b === btn); });
        panels.forEach(function (p) { p.classList.toggle("is-active", p.getAttribute("data-v2-panel") === idx); });
      });
    });
  }
  function initAll() { document.querySelectorAll("[data-v2-tabs]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
  else initAll();
  document.addEventListener("shopify:section:load", initAll);
})();
